import { render, staticRenderFns } from "./PaginateCollection.vue?vue&type=template&id=6257076c&scoped=true&"
import script from "./PaginateCollection.vue?vue&type=script&lang=js&"
export * from "./PaginateCollection.vue?vue&type=script&lang=js&"
import style0 from "./PaginateCollection.vue?vue&type=style&index=0&id=6257076c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6257076c",
  null
  
)

export default component.exports